import { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix leaflet default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

// Custom yellow marker for active repairs
const yellowIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-gold.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

const redIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34],
});

export async function geocodeAddress(address) {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}&limit=1&countrycodes=us`,
      { headers: { 'User-Agent': 'MillennialsMaintenance/1.0' } }
    );
    const data = await res.json();
    if (data[0]) return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
    return null;
  } catch {
    return null;
  }
}

export default function MapView({ lat, lng, label = '', priority = 'medium', height = '300px', className = '' }) {
  if (!lat || !lng) return (
    <div className={`flex items-center justify-center bg-[#0A0F1A] border border-[#2D3F5E] rounded-sm text-[#5C6A7A] font-['IBM_Plex_Sans'] text-sm ${className}`} style={{ height }}>
      No location coordinates — type an address to auto-pin
    </div>
  );

  const icon = priority === 'emergency' ? redIcon : yellowIcon;

  return (
    <div className={`rounded-sm overflow-hidden border border-[#2D3F5E] ${className}`} style={{ height }}>
      <MapContainer center={[lat, lng]} zoom={13} style={{ height: '100%', width: '100%', background: '#0F172A' }} zoomControl={true}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a>'
        />
        <Marker position={[lat, lng]} icon={icon}>
          <Popup>
            <div style={{ fontFamily: 'IBM Plex Sans, sans-serif', fontSize: 13 }}>
              <strong>{label}</strong>
            </div>
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
}

export function MultiRepairMap({ repairs = [], height = '400px', className = '' }) {
  const withCoords = repairs.filter(r => r.lat && r.lng);
  if (withCoords.length === 0) return (
    <div className={`flex items-center justify-center bg-[#0A0F1A] border border-[#2D3F5E] rounded-sm text-[#5C6A7A] font-['IBM_Plex_Sans'] text-sm ${className}`} style={{ height }}>
      No repair locations available
    </div>
  );

  const center = [withCoords[0].lat, withCoords[0].lng];

  return (
    <div className={`rounded-sm overflow-hidden border border-[#2D3F5E] ${className}`} style={{ height }}>
      <MapContainer center={center} zoom={7} style={{ height: '100%', width: '100%' }}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; OpenStreetMap' />
        {withCoords.map(r => (
          <Marker key={r.id} position={[r.lat, r.lng]} icon={r.priority === 'emergency' ? redIcon : yellowIcon}>
            <Popup>
              <div style={{ fontFamily: 'IBM Plex Sans, sans-serif', fontSize: 12 }}>
                <strong>{r.truck_unit_number || 'Unit'}</strong><br />
                {r.issue_description}<br />
                <span style={{ color: '#888' }}>{r.location}</span>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
